import { Component, Input } from '@angular/core';
import {
    FrameworkColumn,
    IAddressDto,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { IIconPopover } from '../modules/icon';

@Component({
    selector: 'pf-address-renderer',
    template: `
        @if (addressName) {
            <pf-text type="primary" bold
                >{{ addressName }}
                @if (infoPopover) {
                    <pf-icon iconType="info" [popover]="infoPopover"></pf-icon>
                }
            </pf-text>
        }
        @if (value) {
            <pf-text [pfMapAction]="value">
                @if (value?.addressLine1) {
                    <div>
                        <pf-icon iconType="location" inline></pf-icon>
                        <span>{{ value.addressLine1 }}</span>
                        @if (value.addressLine2) {
                            <span>, {{ value.addressLine2 }}</span>
                        }
                    </div>
                }
                <div>
                    @if (value.city) {
                        <span>{{ value.city }}</span>
                    }
                    @if (value.geoZone) {
                        <span>, {{ value.geoZone }}</span>
                    }
                    @if (value.postalCode) {
                        <span> {{ value.postalCode }}</span>
                    }
                    @if (value.country) {
                        <span> {{ value.country }}</span>
                    }
                </div>
            </pf-text>
        }
    `,
    styles: [
        `
            :host {
                pf-text {
                    padding: 0;
                }

                pf-icon {
                    color: var(--ant-primary-color);
                }
            }
        `,
    ],
    standalone: false,
})
export class AddressRendererComponent implements ITableCellValueRenderer {
    @Input() value?: IAddressDto;
    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;
    @Input() addressName?: string | null;
    @Input() infoPopover?: IIconPopover;

    get fullAddressString() {
        let addressString = '';
        if (this.addressName) {
            addressString += this.addressName + ' - ';
        }
        if (this.value?.addressLine1) {
            addressString += this.value.addressLine1;
        }
        if (this.value?.addressLine2) {
            addressString += `, ${this.value.addressLine2}`;
        }
        if (this.value?.city) {
            addressString += `, ${this.value.city}`;
        }
        if (this.value?.geoZone) {
            addressString += `, ${this.value.geoZone}`;
        }
        if (this.value?.postalCode) {
            addressString += `, ${this.value.postalCode}`;
        }
        return addressString;
    }
}
